import styled from '@emotion/styled';

import { ButtonV3 } from '@zola/zola-ui/src/components/ButtonV3';

import FONT from '@zola/zola-ui/src/styles/emotion/fonts';
import SPACING from '@zola/zola-ui/src/styles/emotion/spacing';
import { COLORS_TEXT } from '@zola/zola-ui/src/styles/emotion/colors';

export const Container = styled.div`
  width: 568px;
  padding: ${SPACING.XS} ${SPACING.S32} ${SPACING.S32};
`;

export const Title = styled.h2`
  ${FONT.textSizeUltraCompact(FONT.FONT_SIZE_LARGE)};
  margin: 0 0 ${SPACING.SM};
  font-weight: ${FONT.FONT_WEIGHT_BOLD};
`;

export const Subtitle = styled.p`
  color: ${COLORS_TEXT.BODY};
  margin: 0 0 ${SPACING.S32};
`;

export const StyledButton = styled(ButtonV3)`
  margin-top: ${SPACING.S32};
  float: right;
`;

export const InputContainer = styled.div`
  margin-bottom: ${SPACING.S32};
`;
